export const slidercourseConstants = {
    GETALL_REQUEST: 'SLIDERCOURSE_GETALL_REQUEST',
    GETALL_SUCCESS: 'SLIDERCOURSE_GETALL_SUCCESS',
    GETALL_FAILURE: 'SLIDERCOURSE_GETALL_FAILURE',

    DELETE_REQUEST: 'SLIDERCOURSE_DELETE_REQUEST',
    DELETE_SUCCESS: 'SLIDERCOURSE_DELETE_SUCCESS',
    DELETE_FAILURE: 'SLIDERCOURSE_DELETE_FAILURE'
};
